// MODEL : instance of FieldFilter

define('app/filters/FieldFilterView',['require','./AbstractFieldFilterView','app/config/filterTypes','glu/util','glu/dialog','glu/$','hbs!./FieldFilterView.hbs'],function(require) {
	'use strict';

	var AbstractFieldFilterView = require('./AbstractFieldFilterView'),
		FILTER_TYPES = require('app/config/filterTypes'),
		_ = require('glu/util'),
		dialog = require('glu/dialog'),
		$ = require('glu/$');


	return AbstractFieldFilterView.extend({
		template: require('hbs!./FieldFilterView.hbs'),

		className: 'edit-filter',

		events: {
			'change [name=operator]': 'updateModel',
			'click > .btn-delete': 'removeFilter',
			'keypress input, select': 'updateAndSave'
		},

		initialize: function() {
			if (!this.model.getOperator() && this.operators() && this.operators()[0] && this.operators()[0].value) {
				this.model.setOperator(this.operators()[0].value);
			}
			this.listenTo(this.model, 'change:operator', this.renderFilterControl);
			this.listenTo(this.model, 'finishFetchingConstraints', this.renderFilterControl);
		},

		onClose: function() {
			if (this.control) {
				this.control.close();
			}
			if (this.model.validate()) {
				this.model.remove();
			}
		},

		dialogTitle: 'Define Filter',

		getClass: function() {
			return this.className || 'modal-define-filter';
		},

		dialogButtons: [{
			text: 'Define Filter',
			callback: 'save',
			className: 'btn-primary btn-define-filter'
		}],

		onRender: function() {
			this.renderFilterControl();
			this.$('.filter-selection').comboBox();
		},

		renderFilterControl: function() {
			this.resetValues();
			this.control = this.createFilterControl();
			this.$el.find('.filter-control').replaceWith(this.control.render().$el);
		},

		/**
		 * Make sure the values array is consistent with the currently selected operator.
		 */
		resetValues: function() {
			if (this.model.getOperator() !== 'BETWEEN_GTE_LTE' && this.model.getOperator() !== 'IN' && this.model.getOperator() !== 'NIN' && this.model.getOperator() !== 'HAS') {
				this.model.getValues().splice(1, 1);
			}
		},

		serializeData: function() {
			return this;
		},

		operators: function() {
			var self = this;
			var selectedOperator = this.model.getOperator();

			var matchingFilterTypes = _.where(FILTER_TYPES.field, {
				type: this.model.type()
			});

			// filter out 'is one of' if there more then 1000 items
			matchingFilterTypes = _.reject(matchingFilterTypes, function(fld) {
				return fld.inputMethod === 'in' && self.model.possibleValues().length > 1000;
			});

			return _.map(matchingFilterTypes, function(o) {
				return {
					label: o.label,
					value: o.operator,
					isSelected: o.operator === selectedOperator
				};
			});
		},

		fieldName: function() {
			return ($('.page-dashboard.multi-domain').length > 0) ? 'Date' : this.model.fieldName();
		},

		fieldQualifiedName: function() {
			return this.model.fieldQualifiedName();
		},

		id: function() {
			return this.model.cid;
		},

		updateModel: function() {
			this.model.setOperator(this.$el.find('[name=operator]').val());
		},

		removeFilter: function(evt) {
			evt.preventDefault();
			this.model.remove();
		},

		hasSelection: function() {
			return this.model.type() !== 'BOOL';
		},

		updateAndSave: function(e) {
			var code = e.keyCode || e.which;

			if (code === 13 && this.isSingleFilterEdit()) {
				this.updateModel();
				this.save();
			}
		},

		isSingleFilterEdit: function() {
			return $('.btn-define-filter').length === 1;
		},

		save: function() {
			if (this.model.isValid()) {
				dialog.close();
				this.appBus.trigger('refresh');
			}
		}
	});

});

